<template>
    <div
        class="border-stroke-1 bg-killer clip-left-corner relative flex h-60 w-full flex-col justify-between border-1 p-4"
        :class="comingSoon ? 'cursor-not-allowed' : 'cursor-pointer'"
        :style="{
            backgroundImage: `url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
        }"
        @click.self="comingSoon ? null : startGame()"
    >
        <div class="flex justify-between pointer-events-none">
            <div class="font-title mb-0 bg-red-600 px-4 py-2 !text-xs font-bold uppercase">
                {{ title }}
            </div>
            <div v-if="!comingSoon" @click.stop="openGameExplanation()" class="pointer-events-auto">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.50059 4.21606C13.4983 0.758474 21 5.07897 21 12.0003C21 15.2121 19.284 18.1793 16.4994 19.7846L16.4994 19.7846C10.5017 23.2422 3 18.9217 3 12.0003C3 8.78849 4.71602 5.82135 7.50058 4.21607L7.50059 4.21606ZM19 12.0003C19 6.62318 13.1684 3.25723 8.49945 5.94876L8.00002 5.08241L8.49945 5.94876C6.33348 7.19744 5 9.50447 5 12.0003C5 17.3775 10.8316 20.7434 15.5005 18.0519C17.6665 16.8032 19 14.4962 19 12.0003ZM13 7.00032L13 8.50032L11 8.50032L11 7.00032L13 7.00032ZM13 10.0003V17.0003H11V10.0003H13Z"
                        fill="white"
                    />
                </svg>
            </div>
        </div>

        <div class="flex justify-between">
            <div class="grid grid-cols-1 gap-2">
                <div>
                    <button-transparent>
                        <span class="text-[10px] leading-none font-bold tracking-tight">{{
                            players
                        }}</span>
                        <svg
                            class="-mt-0.5 h-4"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.40084 3.90167C8.59299 3.14158 7.37257 3.14389 6.56722 3.9086C5.80452 4.63282 5.80651 5.91694 6.59566 6.76286C7.31003 7.52862 8.57265 7.52756 9.40818 6.73418C10.1861 5.99555 10.2092 4.72473 9.40084 3.90167ZM5.64913 2.94172C6.97148 1.6861 9.00394 1.68609 10.3263 2.94172C10.3312 2.94635 10.336 2.95106 10.3407 2.95585C11.6553 4.28208 11.6763 6.4192 10.3263 7.70107C9.03169 8.93034 6.91116 9.05569 5.6207 7.67239C4.40502 6.36925 4.2817 4.24014 5.64913 2.94172ZM3.99936 10.6667C3.99936 10.6667 3.99936 11.7401 3.99936 13.3333L3.33268 13L2.66602 12.6667C2.66602 11.3109 2.66602 10.4912 2.66602 10L2.99935 9.66667L3.33268 9.33333H12.666L12.9993 9.66667L13.3327 10C13.3327 10.5671 13.3327 11.4785 13.3327 12.6667L12.666 13L11.9994 13.3333C11.9994 11.795 11.9994 10.6667 11.9994 10.6667H3.99936Z"
                                fill="white"
                            />
                        </svg>
                    </button-transparent>
                </div>
                <div>
                    <button-transparent>
                        <span
                            class="text-[10px] leading-none font-bold tracking-tight capitalize"
                            >{{ difficulty }}</span
                        >
                        <svg
                            class="-mt-0.5 h-4"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M5.6 4.4L8 2L10.4 4.4L8 6.8L5.6 4.4Z" stroke="white" />
                            <path d="M5.6 11.6L8 9.2L10.4 11.6L8 14L5.6 11.6Z" stroke="white" />
                            <path d="M2 8L4.4 5.6L6.8 8L4.4 10.4L2 8Z" stroke="white" />
                            <path d="M9.2 8L11.6 5.6L14 8L11.6 10.4L9.2 8Z" stroke="white" />
                        </svg>
                    </button-transparent>
                </div>
            </div>
            <div class="mt-auto">
                <DiagonalCutButton
                    v-if="!comingSoon"
                    variant="primary"
                    cut-position="left-top"
                    padding="px-1.5 py-0.5"
                    :data-testid="`game-banner-play-${id}`"
                    @click.stop="startGame"
                >
                    <span class="px-2 text-sm font-black">{{ $t('games.play') }}</span>
                </DiagonalCutButton>
                <DiagonalCutButton
                    v-else
                    variant="secondary"
                    cut-position="left-top"
                    padding="px-1.5 py-0.5"
                    disabled
                >
                    <span class="px-2 text-sm font-black">{{ $t('games.coming_soon') }}</span>
                </DiagonalCutButton>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonTransparent from '@/components/ui/buttons/Transparent.vue'
import DiagonalCutButton from '@/components/ui/DiagonalCutButton.vue'

export default {
    components: {
        ButtonTransparent,
        DiagonalCutButton,
    },
    methods: {
        openGameExplanation() {
            console.log('Opening explanation for key: ' + this.id)

            this.$serviceBus.emit('open-game-explanation', {
                key: this.id,
                infoOnly: this.comingSoon,
            })
        },
        startGame() {
            this.$emit('start-game', this.id)
        },
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
        players: {
            type: String,
            required: true,
        },
        difficulty: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        comingSoon: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
